import { render, staticRenderFns } from "./statusinfonew.vue?vue&type=template&id=e3fbf23a&scoped=true"
import script from "./statusinfonew.vue?vue&type=script&lang=js"
export * from "./statusinfonew.vue?vue&type=script&lang=js"
import style0 from "./statusinfonew.vue?vue&type=style&index=0&id=e3fbf23a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fbf23a",
  null
  
)

export default component.exports